import { fork, all } from 'redux-saga/effects';
import * as notifications from './notifications';
export default function* rootSaga() {
  yield all([...Object.values(notifications)].map(fork));
}
